import React ,{Suspense}from 'react';
import { Routes, Route } from 'react-router-dom';
import AppLandingPage from '../Login/Pages/AppLandingPage';
import Dashboard from '../Modules/Dashboard/Dashboard';
import FixturesHistory from '../Modules/Fixtures/FixturesHistory';
import FixturesPlayersDetails from '../Modules/Fixtures/FixturesPlayersDetails';
import Information from '../Modules/Fixtures/Information';
import InformationWithTeam from '../Modules/Fixtures/InformationWithTeam';
import Luminaires from '../Modules/Luminaires/Luminaires';
import Auth from '../Layout/Auth';
import TeamManagement from '../Modules/Team/TeamManagement';
import Preview from '../Modules/Team/Preview';
import Tournaments from '../Modules/Tournaments/Tournaments';
import TournamentsEvents from '../Modules/Tournaments/TournamentsEvents';
import TournamentsMatches from '../Modules/Tournaments/TournamentsMatches';
import TournamentsDetails from '../Modules/Tournaments/TournamentsDetails';
import CreateTournament from '../Modules/Tournaments/CreateTournament';
import CreateTeam from '../Modules/Team/CreateTeam';

import { useLocation } from "react-router-dom";
import {useDispatch } from 'react-redux';
import { setActiveLink } from '../slices/mainSlice';
import Setting from '../Modules/Setting/Setting';
import Result from '../Modules/Result/Result';
import Ranking from '../Modules/Ranking/Ranking';
import User from '../Modules/User/User';
import Stats from '../Modules/Stats/Stats';
import PlayerManagement from '../Modules/Team/PlayerManagement';
import Coach from '../Modules/Coach/Coach';
import Sponsor from '../Modules/Sponsor/Sponsor';
import Referee from '../Modules/Referee/Referee';
import CreateMatch from '../Modules/Match/CreateMatch';
import UpcomingMatches from '../Modules/Match/UpcomingMatches';

const GlobalRoutes = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const parts = location.pathname.split("/");
    const page = parts[2];
    dispatch(setActiveLink(page));  

    return (
        <Routes>
            <Route path="/" element={<Auth><Suspense fallback={<div>Loading...</div>}>
                <AppLandingPage />
            </Suspense></Auth>} />
            <Route path="dashboard" element={<Auth><Suspense fallback={<div>Loading...</div>}>
                <Dashboard />
            </Suspense></Auth>} />
            <Route path="fixtures/history" element={<Auth><Suspense fallback={<div>Loading...</div>}>
                <FixturesHistory />
            </Suspense></Auth>} />
            <Route path="fixtures/information" element={<Auth><Suspense fallback={<div>Loading...</div>}>
                <Information />
            </Suspense></Auth>} />
            <Route path="fixtures/information-with-team" element={<Auth><Suspense fallback={<div>Loading...</div>}>
                <InformationWithTeam />
            </Suspense></Auth>} />
            <Route path="fixtures/players/:playerId" element={<Auth><Suspense fallback={<div>Loading...</div>}>
                <FixturesPlayersDetails />
            </Suspense></Auth>} />
            <Route path="luminaires" element={<Auth><Suspense fallback={<div>Loading...</div>}>
                <Luminaires />
            </Suspense></Auth>} />
            <Route path="create-team" element={<Auth><Suspense fallback={<div>Loading...</div>}>
                <CreateTeam />
            </Suspense></Auth>} />
            <Route path="team-management" element={<Auth><Suspense fallback={<div>Loading...</div>}>
                <TeamManagement />
            </Suspense></Auth>} />
            <Route path="preview" element={<Auth><Suspense fallback={<div>Loading...</div>}>
                <Preview />
            </Suspense></Auth>} />
            <Route path="tournaments" element={<Auth><Suspense fallback={<div>Loading...</div>}>
                <Tournaments />
            </Suspense></Auth>} />
            <Route path="tournaments-events" element={<Auth><Suspense fallback={<div>Loading...</div>}>
                <TournamentsEvents />
            </Suspense></Auth>} />
            <Route path="tournaments-events/:tournamentId" element={<Auth><Suspense fallback={<div>Loading...</div>}>
                <TournamentsMatches />
            </Suspense></Auth>} />
            <Route path="tournaments/details" element={<Auth><Suspense fallback={<div>Loading...</div>}>
                <TournamentsDetails />
            </Suspense></Auth>} />
            <Route path="create-match/:tournamentId" element={<Auth><Suspense fallback={<div>Loading...</div>}>
                <CreateMatch />
            </Suspense></Auth>} />
            <Route path="upcoming-matches" element={<Auth><Suspense fallback={<div>Loading...</div>}>
                <UpcomingMatches />
            </Suspense></Auth>} />
            <Route path="create-tournament" element={<Auth><Suspense fallback={<div>Loading...</div>}>
                <CreateTournament />
            </Suspense></Auth>} />
            <Route path="manage-player" element={<Auth><Suspense fallback={<div>Loading...</div>}>
                <PlayerManagement />
            </Suspense></Auth>} />
            <Route path="stats" element={<Auth><Suspense fallback={<div>Loading...</div>}>
                <Stats />
            </Suspense></Auth>} />
            <Route path="results" element={<Auth><Suspense fallback={<div>Loading...</div>}>
                <Result />
            </Suspense></Auth>} />
            <Route path="user" element={<Auth><Suspense fallback={<div>Loading...</div>}>
                <User />
            </Suspense></Auth>} />
            <Route path="ranking" element={<Auth><Suspense fallback={<div>Loading...</div>}>
                <Ranking />
            </Suspense></Auth>} />
            <Route path="referee" element={<Auth><Suspense fallback={<div>Loading...</div>}>
                <Referee />
            </Suspense></Auth>} />
            <Route path="coach" element={<Auth><Suspense fallback={<div>Loading...</div>}>
                <Coach />
            </Suspense></Auth>} />
            <Route path="sponsor" element={<Auth><Suspense fallback={<div>Loading...</div>}>
                <Sponsor />
            </Suspense></Auth>} />
            <Route path="setting" element={<Auth><Suspense fallback={<div>Loading...</div>}>
                <Setting />
            </Suspense></Auth>} />
        </Routes>
    );
}
export default GlobalRoutes;